import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { AssetHierarchyComponent } from "../../shared/widgets/asset-hierarchy/asset-hierarchy.component";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";

import { ASSET_TYPES, AssetType } from "../../enums/assetTypes.enum";
import { PermissionService } from "../../services/api/permission/permission.service";

import { HasPermissionDirective } from "../../shared/directives/has-permission/has-permission.directive";

@Component({
  standalone: true,
  selector: "app-asset-administration",
  imports: [AssetHierarchyComponent, RouterModule, HasPermissionDirective],
  templateUrl: "./asset-administration.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./asset-administration.component.scss",
})
export class AssetAdministrationComponent {
  private readonly router = inject(Router);
  public readonly permissions = inject(PermissionService);
  private readonly route = inject(ActivatedRoute);

  public initialSelectedAssetId: string | null;
  public initialSelectedAssetType: string | null;

  constructor() {
    this.initialSelectedAssetType = this.extractUrlAssetType();
    this.initialSelectedAssetId = this.route.firstChild?.snapshot.params["id"] ?? null;
  }

  /**
   * Gets the asset type and asset id based on the URL
   */
  private extractUrlAssetType() {
    const path = this.route.firstChild?.snapshot.routeConfig?.path?.split("/")[0];
    if (path === "gateDetails") {
      return ASSET_TYPES.GATE_SYSTEM;
    } else if (path === "tenantDetails") {
      return ASSET_TYPES.TENANT;
    } else if (path === "assetDetails") {
      return this.route.snapshot.queryParams["assetType"];
    } else {
      return null;
    }
  }

  /**
   * Navigates to the asset details page of the selected asset.
   * @param event Event containing the id and assetType of the asset to navigate to.
   */
  public selectAsset(event: { id: string; assetType: AssetType }) {
    const assetType: string = event.assetType;
    const assetId: string = event.id;
    if (assetType === ASSET_TYPES.GATE_SYSTEM) {
      this.router.navigate(["dashboard/assetAdministration/gateDetails", assetId]);
    } else if (assetType === ASSET_TYPES.TENANT) {
      this.router.navigate(["dashboard/assetAdministration/tenantDetails"]);
    } else {
      this.router.navigate(["dashboard/assetAdministration/assetDetails", assetId], {
        queryParams: { assetType: assetType },
      });
    }
  }
}
